/**
 * shim for promises (required by IE <= 11)
 */
require('es6-promise').polyfill();

var visitorContextUtil = require('src/interlock/no-ui/utils/visitor-context/visitor-context'),
    enhanceLinkAttribution = require('src/interlock/no-ui/utils/link-attribution/link-attribution'),
    reqParamsToCookie = require('src/interlock/no-ui/req-params-to-cookie/req-params-to-cookie');

var darklaunch = require('src/interlock/no-ui/utils/darklaunch/darklaunch');
var darklaunched = darklaunch.storyEnabled('TMT-163');
/**
 * Ensure namespaces
 */
window.EDM.PageValues = window.EDM.PageValues || {};
window.EDM.visitor = window.EDM.visitor || {};

/**
 * Generate unique ids for all links on page
 */
enhanceLinkAttribution($);
/**
 * Create visitor context if it does not exist and set to window.EDM.visitor object
 * @type {{}}
 */
visitorContextUtil(window.EDM)
    .addVisitorId()
    .addSessionId();

/**
 * Ads
 */
var ads = require('src/interlock/product/ads/index');
if (darklaunched) {
    $(document).ready(function () {
        ads.install();
        $('.punit').asyncGptTag({});
        ads.adEvents.subscribe();
        ads.adManager.renderAds();
    });
} else {
    ads.install().then(function() {
        $(document).ready(function () {
            $('.punit').asyncGptTag({});
            ads.adEvents.subscribe();
            ads.adManager.renderAds();
        });
    })
    .catch(function() {
        // has been rejected
        // console.log('error', error);
    });
}

/**
 * Checks request params and add cookies to disable ads if there are following request params:
 * - disableallads
 * - disableallthirdparty
 * - disableadid
 * - disableadposition
 * - disableadtype
 */
var adDisableParams = ['disableallads', 'disableallthirdparty', 'disableadid', 'disableadposition', 'disableadtype'];
reqParamsToCookie.setSelfValues(adDisableParams);

require('src/interlock/no-ui/ad-refresh/ad-refresh');
require('src/creative/no-ui/engagement-handler/engagement-handler');

/**
 * Break bfcache in Firefox and Safari browsers
 */
$(window).on('pageshow', function(event) {
    if (event.originalEvent.persisted) {
        window.location.reload();
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/creative/init/init.js
// module id = 467
// module chunks = 36